/**
 * Router.js por módulo 
 * 
 * @author Daniel Lepe
 * @version 1.0
 * @date 7/12/2023
 */
 
const rootPath = '/exhibidores',
    rootName = 'Exhibidores',
    indexUri = 'index';

const router = {
    path: rootPath,
    redirect: rootPath + '/' + indexUri,
    component: () => import('@/containers/DefaultContainer'),
    children: [
        {
            path: indexUri,
            name: rootName,
            component: () => import('./quicktable.vue')
        }
    ]
}

// EASYLUNCH
const nav = {
    name: rootName,
    url: rootPath,
    icon: 'fa fa-cog'
}

export {
    rootPath, rootName,
    router,
    nav
}